<ng-container>
    <div class="container-fluid">
        <div class="card-body row py-3 px-0 providers-hldr">
            <!-- Provider Form (always visible) -->
            <div class="w-100 provider-form">
                <h4 class="mb-3" *ngIf="editMode">Edit Provider</h4>
                <h4 class="mb-3" *ngIf="!editMode">Add Provider</h4>

                <!-- NPI Lookup Component -->
                <div class="mb-3" *ngIf="!selectedProvider">
                    <app-npi-lookup
                        label="Search Provider"
                        [allowManualEntry]="true"
                        (providerSelected)="onProviderSelected($event)"
                        (providerCleared)="onProviderCleared()"
                    ></app-npi-lookup>
                </div>

                <!-- Selected Provider Summary -->
                <div *ngIf="selectedProvider" class="mb-3">
                    <div class="selected-provider-card">
                        <div class="provider-card-body">
                            <div class="provider-card-info">
                                <div class="provider-card-name">
                                    {{ selectedProvider.fullName }}
                                    <span class="provider-credential" *ngIf="selectedProvider.credential">{{ selectedProvider.credential }}</span>
                                </div>
                                <div class="provider-card-details">
                                    <span *ngIf="selectedProvider.providerType" class="provider-detail-tag">{{ selectedProvider.providerType }}</span>
                                    <span *ngIf="selectedProvider.npi" class="provider-detail-tag">NPI: {{ selectedProvider.npi }}</span>
                                </div>
                                <div class="provider-card-meta" *ngIf="selectedProvider.practiceAddress || selectedProvider.phone">
                                    <span *ngIf="selectedProvider.practiceAddress"><i class="pi pi-map-marker"></i> {{ selectedProvider.practiceAddress }}</span>
                                    <span *ngIf="selectedProvider.phone"><i class="pi pi-phone"></i> {{ selectedProvider.phone }}</span>
                                </div>
                            </div>
                            <button type="button" class="provider-card-remove" (click)="onProviderCleared()">
                                <i class="pi pi-times"></i>
                            </button>
                        </div>
                    </div>

                    <!-- Notes -->
                    <div class="mt-3">
                        <label>Notes</label>
                        <textarea
                            class="form-control form-control-lg form-control-solid"
                            placeholder="Relationship to patient, referral info, etc."
                            [(ngModel)]="providerNotes"
                            rows="2"
                        ></textarea>
                    </div>

                    <!-- Action Buttons -->
                    <div class="flex flex-row justify-content-end align-items-center gap-2 mt-3">
                        <button *ngIf="editMode" pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text text-secondary" (click)="cancelEdit()"></button>
                        <button
                            pButton pRipple
                            [label]="editMode ? 'Update' : 'Add Provider'"
                            [icon]="editMode ? 'pi pi-check' : 'pi pi-plus'"
                            class="p-button-primary"
                            [disabled]="loading"
                            (click)="onSubmit()"
                        >
                            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Providers List -->
            <div class="w-100 mt-4">
                <app-inline-loader *ngIf="loadingData"></app-inline-loader>
                <div *ngIf="!loadingData">
                    <div class="flex flex-column w-100" *ngIf="leadProviders && leadProviders.length">
                        <h4 class="mb-2">Current Providers</h4>
                        <div class="provider-list">
                            <div *ngFor="let prov of leadProviders" class="provider-card">
                                <ng-container *ngIf="parseProvider(prov.value) as data">
                                    <div class="prov-card-body">
                                        <div class="prov-info">
                                            <div class="prov-name">
                                                {{ data.name }}
                                                <span class="prov-credential" *ngIf="data.credential">{{ data.credential }}</span>
                                                <span class="prov-source-badge" *ngIf="data.source === 'npi_lookup'">NPI Verified</span>
                                            </div>
                                            <div class="prov-details" *ngIf="data.type || data.npi">
                                                <span *ngIf="data.type" class="prov-detail-tag">{{ data.type }}</span>
                                                <span *ngIf="data.npi" class="prov-detail-tag">NPI: {{ data.npi }}</span>
                                            </div>
                                            <div class="prov-meta" *ngIf="data.address || data.phone">
                                                <span *ngIf="data.address"><i class="pi pi-map-marker"></i> {{ data.address }}</span>
                                                <span *ngIf="data.phone"><i class="pi pi-phone"></i> {{ data.phone }}</span>
                                            </div>
                                            <div class="prov-notes" *ngIf="data.notes">
                                                <i class="pi pi-info-circle mr-1"></i> {{ data.notes }}
                                            </div>
                                        </div>
                                        <div class="prov-actions">
                                            <i class="pi pi-pencil blue-icon mx-2" (click)="editProvider(prov)"></i>
                                            <i class="pi pi-trash red-icon" (click)="deleteProvider(prov.id)"></i>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!leadProviders || !leadProviders.length" class="text-muted py-3">
                        No providers recorded.
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<p-confirmDialog styleClass="dark-glass-dialog" appendTo="body" [style]="{ width: '50vw' }" key="leadProviderDelete" [baseZIndex]="10000"></p-confirmDialog>
